// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3570":"dce368cd","7359":"7fb128f4"}[chunkId] + ".chunk.css";
};